module.exports = __webpack_public_path__ + "media/goforajourney/img/find-sagrada-familia-f29c34dbd31063cc7b159225e37a86e8.jpg";